










import { Component, Vue } from 'vue-property-decorator'
import { ReferralStats } from '@/api/model/referral-stats'
import { ReferralCount, ReferralStatus } from '@/api/types'
import { CredentialsType } from '@/api/types'
import { ActiveCampaignCredentials } from '@/api/model/credentials'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')

@Component
export default class StatusTabs extends Vue {
    @referrals.State readonly referralStats!: ReferralStats
    @referrals.State readonly referralCounts!: ReferralCount
    @referrals.State readonly statusFilter!: string

    get statuses(): ReferralStatus[] {
        let statuses = []

        if (this.$currentCompany.pipelinesEnabled) {
            statuses = [
                ReferralStatus.PROCESSED,
                ReferralStatus.SUCCESSFUL,
                ReferralStatus.CLOSED,
            ]
        } else {
            statuses = [
                null,
                ReferralStatus.NEW,
                ReferralStatus.UNREACHABLE,
                ReferralStatus.PENDING,
                ReferralStatus.APPOINTMENT,
                ReferralStatus.PROPOSAL,
                ReferralStatus.ON_HOLD,
                ReferralStatus.SUCCESSFUL,
                ReferralStatus.CLOSED,
                ReferralStatus.PROCESSED,
            ]
        }

        return statuses.filter(status => this.isStatusVisible(status))
    }

    isStatusVisible(status: string): boolean {
        // Currently filtered status is always visible
        if (status === this.statusFilter) {
            return true
        }

        // All statuses except status "processed" are always visible
        if (status !== ReferralStatus.PROCESSED) {
            return true
        }

        // Status "processed" is visible if it has entries.
        if (status === ReferralStatus.PROCESSED && this.countForStatusProcessed > 0) {
            return true
        }

        // Status "processed" is visible if Emma is enabled
        const credentials = this.$currentCompany.getCredentialsWithType(CredentialsType.ACTIVE_CAMPAIGN)
        if (credentials.length === 0) {
            return false
        }

        const activeCampaignCredentials = credentials[0] as ActiveCampaignCredentials
        if (!activeCampaignCredentials.enabled) {
            return false
        }

        return true
    }

    get countForStatusProcessed(): number {
        if (this.$currentCompany.pipelinesEnabled) {
            return this.referralStats.countForStatus(ReferralStatus.PROCESSED)
        } else {
            return this.referralCounts.statusProcessed
        }
    }

    get componentClasses() {
        return [
            'grid',
            `grid-cols-${this.statuses.length}`,
            'gap-1',
        ]
    }
}
